// extracted by mini-css-extract-plugin
export default {"button":"Ok-z","reviewSort":"Pk-z"};